// h-[5vh]

import React from "react";

export function Footer({ className, ...props }) {
    return (
        <footer className="h-[30px] supports-backdrop-blur:bg-background/60 sticky bottom-0 z-50 w-full border-t bg-background/95 backdrop-blur">
            <div className="flex items-center justify-center px-8 h-full">
                © FIBA LLC {new Date().getFullYear()}
            </div>
        </footer>
    );
}